import React from 'react';

const Hero = () => {
    return (
        <div className="pricing-hero">
            <h1>Pricing</h1>
            <h3>Free equity investments and flat ₹20 traday and F&O trades</h3>
            
            <div className="pricing-header-row">
                <div className="pricing-box">
                    <img src="media/images/pricing0.svg" alt="Free equity delivery" />
                    <h2>Free equity delivery</h2>
                    <p>All equity delivery investments (NSE, BSE), are absolutely free — ₹ 0 brokerage.</p>
                </div>
                <div className="pricing-box">
                    <img src="media/images/intradayTrades.svg" alt="Intraday and F&O" />
                    <h2>Intraday and F&O trades</h2>
                    <p>Flat ₹ 20 or 0.03% (whichever is lower) per executed order on intraday trades across equity, currency, and commodity trades. Flat ₹20 on all option trades.</p>
                </div>
                <div className="pricing-box">
                    <img src="media/images/pricingMF.svg" alt="Free mutual funds" />
                    <h2>Free direct MF</h2>
                    <p>All direct mutual fund investments are absolutely free — ₹ 0 commissions & DP charges.</p>
                </div>
            </div>
        </div>
    );
};

export default Hero;
